import { Action } from 'redux';

import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { GetContentDetail, UpdateContentDetail } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

/**
 * Only the ExploreContentApi item types are eligible for requesting detailed items,
 * but for simplicity of dispatching from the views, we can pass in any explorable item type,
 * and the saga makes the API call only for the eligible item types.
 */
export interface GetContentDetailAction extends Action {
  content: IExplorableItemTypeInfo;
}

export function getContentDetail(content: IExplorableItemTypeInfo) : GetContentDetailAction {
  return {
    type: GetContentDetail,
    content
  };
}

export const isGetContentDetailAction = isActionFactory<GetContentDetailAction>(GetContentDetail);

export interface UpdateContentDetailAction extends Action {
  content: IExplorableItemTypeInfo[];
}

export function updateContentDetail(...content: IExplorableItemTypeInfo[]): UpdateContentDetailAction {
  return {
    type: UpdateContentDetail,
    content
  };
}

export const isUpdateContentDetailAction = isActionFactory<UpdateContentDetailAction>(UpdateContentDetail);
